import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private _baseUrl = `${environment.apiURL}/api`;
  public get baseUrl() {
    return this._baseUrl;
  }
  public set baseUrl(value) {
    this._baseUrl = value;
  }
  constructor(private http: HttpClient, private authService: AuthService) { }

  currentUser = this.authService.currentUserValue;

  //////////////////////////////////////////not modified ///////////////////////////////////////////

  getSapProductsSync(){
    return this.http.get<any>(`${this._baseUrl}/product/sync`);
  }
  
  getProducts(){
    return this.http.get<any>(`${this._baseUrl}/product`);
  }

  getFactoryProducts(factoryId : number){
    return this.http.get<any>(`${this._baseUrl}/product/GetFactoryItems/${factoryId}`);
  }

  // getProductsQuantities(pageIndex = 1, pageSize = 25, pagination = false, criteria = null, warehouseId = null){
  //   return this.http.get<any>(`${this._baseUrl}/product/getProductsQuantities?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? "&criteria="+criteria : ""}${warehouseId != null ? "&warehouseId="+warehouseId : ""}`)
  // }

  getPaginatedProducts(pageIndex = 0, pageSize = 10, pagination = false, criteria = null, isActive = -1){
    return this.http.get<any>(`${this._baseUrl}/product/paginated/${isActive}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? "&criteria="+criteria : ""}`)
  }

  getLastSapSync(){
    return this.http.get<any>(`${this._baseUrl}/product/LastSyncDate`);
  }

  updateProducts(){
    return this.http.get<any>(`${this._baseUrl}/product/sync`);
  }
  
  // getCustomerProducts(id: string){
  //   return this.http.get<any>(`${this._baseUrl}/product/customer/${id}`);
  // }

  // getProductById(id: number){
  //   return this.http.get<any>(`${this._baseUrl}/product/${id}`);
  // }

  // getProductDefaultWarehouseQuantity(id: number){
  //   return this.http.get<any>(`${this._baseUrl}/product/${id}/quantity`);
  // }
  // getProductWarehouseQuantity(id: number, warehouse: number){
  //   return this.http.get<any>(`${this._baseUrl}/product/${id}/quantity/${warehouse}`);
  // }

  // changeProductStatus(id: number, status: boolean){
  //   return this.http.patch<any>(`${this._baseUrl}/product/status/${id}/${status}`, null);
  // }

  // changeProductWarehouse(id: number, warehouseId: number){
  //   return this.http.patch<any>(`${this._baseUrl}/product/${id}/warehouse/${warehouseId}`, null);
  // }
  // changeProductCategory(id: number, categoryId: number){
  //   return this.http.patch<any>(`${this._baseUrl}/product/${id}/category/${categoryId}`, null);
  // }

  // checkProductSetQuantity(id: number, quantity: number) {
  //   return this.http.get<any>(`${this._baseUrl}/product/CheckQuantity/${id}/${quantity}`)
  // }

  // attachImage(product) {
  //   const form = new FormData();
  //   form.append("ProductId", product.productId);
  //   form.append("Image", product.image);
  //   return this.http.post<any>(`${this._baseUrl}/product/attachImage`, form);
  // }
  // attachAllImageProduct(imageFolder: string) {
  //   const body = JSON.stringify(imageFolder); // Ensure the body is properly formatted
  //   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  //   return this.http.post<any>(`${this._baseUrl}/product/folderPath`, body , { headers });
  // }



  // updateProduct(itemCode: string){
  //   const itemCodeEncoded = encodeURIComponent(itemCode);
  //   return this.http.get<any>(`${this._baseUrl}/product/sync/${itemCodeEncoded}`);
  // }


  // updateProductAndGetDefaultWareHouseQuantity(itemCode: string,itemId:number){
  //   const itemCodeEncoded = encodeURIComponent(itemCode);
  //   return this.http.get<any>(`${this._baseUrl}/product/sync/${itemCodeEncoded}/id/${itemId}`);
  // }


  // updateProductsQuantities(itemCodes: string[]){
  //   itemCodes.forEach(code => code = encodeURIComponent(code));
  //   return this.http.post<any>(`${this._baseUrl}/product/sync/codes`, itemCodes);
  // }

  // getSapProductQuantity(id: number, warehouseId: number) {
  //   return this.http.get<any>(`${this._baseUrl}/product/SAP/${id}/Quantity/${warehouseId}`);
  // }
}